import * as React from "react";
const SvgShortTextOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M4 9h16v2H4V9zm0 4h10v2H4v-2z" />
  </svg>
);
export default SvgShortTextOutlined;
